var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from "react";
import otcDi from "../../../../mainDi/features/OTC/servicelocator";
import { useSelector } from "react-redux";
import { removeEmptyObjects } from "@frameworks/NCD/Utils/removeEmptyObjects";
import { EBuySell } from "@frameworks/NCD/Enum/OTC";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/CashFlow";
export var useSaveOrder = function () {
    var searchParams = new URLSearchParams(location.search);
    var _a = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }), selectedClientDetails = _a.selectedClientDetails, transactionDetails = _a.transactionDetails, transactionJourney = _a.transactionJourney, paymentMode = _a.paymentMode, purchaseFee = _a.purchaseFee, draftOrderDetails = _a.draftOrderDetails, bankCodeDetails = _a.bankCodeDetails, transactionId = _a.transactionId, dirtyPriceDetails = _a.dirtyPriceDetails;
    var watchListRequestPayload = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).watchListRequestPayload;
    var _b = __read(useState(false), 2), loading = _b[0], setLoading = _b[1];
    var _c = __read(useState(false), 2), error = _c[0], setError = _c[1];
    var selectedBankObject = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName;
    var handleSaveOrder = function () { return __awaiter(void 0, void 0, void 0, function () {
        var req, res, err_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    req = removeEmptyObjects({
                        acCode: selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.accountCode,
                        bank_Acc_No: (_a = selectedBankObject === null || selectedBankObject === void 0 ? void 0 : selectedBankObject.bank_acc_no) !== null && _a !== void 0 ? _a : "",
                        dP_ID: transactionJourney.dpDetails,
                        isin: Number(transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.isin_id),
                        quantity: Number(transactionJourney.quantity),
                        dirty_Price: Number(transactionJourney.dirtyPrice),
                        payment_Mode: (_b = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.type) !== null && _b !== void 0 ? _b : "",
                        sB_Code: (_d = (_c = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.sbName) === null || _c === void 0 ? void 0 : _c.display_code) !== null && _d !== void 0 ? _d : "",
                        payout: (purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout) === "null" ? "" : (_e = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout) !== null && _e !== void 0 ? _e : "",
                        reference_No: String((paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.rtgsNo) || (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo) || ""),
                        bank_Code: (_h = (_g = (_f = bankCodeDetails === null || bankCodeDetails === void 0 ? void 0 : bankCodeDetails.data) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.bank_code) !== null && _h !== void 0 ? _h : "",
                        setup_Fees_percentage: (_j = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.setUpFees) !== null && _j !== void 0 ? _j : null,
                        leadId: "",
                        draft_id: String(transactionId),
                        buy_sell_flag: (transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.buySellFlag) === EBuySell.Sell
                            ? EBuySellFlag.SELL
                            : EBuySellFlag.BUY,
                        client_name: selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.clientName,
                        pan: selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.pan,
                        mobile: selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.mobileNo,
                        email: selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.email,
                        amount: ((_k = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _k === void 0 ? void 0 : _k.amount) || ((_l = dirtyPriceDetails === null || dirtyPriceDetails === void 0 ? void 0 : dirtyPriceDetails.data) === null || _l === void 0 ? void 0 : _l.amount),
                        lead_id: searchParams.get("leadid") !== undefined &&
                            searchParams.get("leadid") !== null &&
                            searchParams.get("leadid") !== ""
                            ? searchParams.get("leadid")
                            : "",
                        order_source: "web",
                    });
                    _o.label = 1;
                case 1:
                    _o.trys.push([1, 5, 6, 7]);
                    setLoading(true);
                    return [4 /*yield*/, otcDi.transactionJourney.saveOrder(req)];
                case 2:
                    res = _o.sent();
                    if (!(((_m = res === null || res === void 0 ? void 0 : res.data) === null || _m === void 0 ? void 0 : _m.status) === "SUCCESS")) return [3 /*break*/, 4];
                    return [4 /*yield*/, otcDi.productBouquet.getDraftOrderCount({
                            categoryCode: Number(watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.category_code),
                            buy_sell_Flag: watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg,
                        })];
                case 3:
                    _o.sent();
                    _o.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5:
                    err_1 = _o.sent();
                    setError(true);
                    return [3 /*break*/, 7];
                case 6:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return { loading: loading, error: error, handleSaveOrder: handleSaveOrder };
};
